import '@/App.css';
import { Toaster } from 'sonner';
import { useLenis } from '@/hooks/useLenis';
import { Navbar } from '@/components/landing/Navbar';
import { Hero } from '@/components/landing/Hero';
import { Welcome } from '@/components/landing/Welcome';
import { About } from '@/components/landing/About';
import { WhatWeDo } from '@/components/landing/WhatWeDo';
import { Expertise } from '@/components/landing/Expertise';
import { Concept } from '@/components/landing/Concept';
import { Government } from '@/components/landing/Government';
import { Team } from '@/components/landing/Team';
import { Partners } from '@/components/landing/Partners';
import { Project } from '@/components/landing/Project';
import { Contact } from '@/components/landing/Contact';
import { Footer } from '@/components/landing/Footer';

function App() {
  useLenis();

  return (
    <div className="relative min-h-screen bg-navy-950 text-white selection:bg-gold">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Welcome />
        <About />
        <WhatWeDo />
        <Expertise />
        <Concept />
        <Government />
        <Team />
        <Partners />
        <Project />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: '#0A192F',
            border: '1px solid rgba(197,160,89,0.4)',
            color: '#fff',
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
